import { DefaultOptionType } from 'antd/es/select';
import React from 'react';

import { UserShortConnectionFragment } from './graphql/fragments/UserShortConnectionFragment';
import { UserShortFragment } from './graphql/fragments/UserShortFragment';
import { UserShortListFragment } from './graphql/fragments/UserShortListFragment';
import { UsersShortQuery } from './graphql/UsersShortQuery';
import { DynamicList } from './index';
import { DynamicFilterListType, RowsFilterType, UserType } from './types';

interface IUserSelect {
    onChange?: (value: string, option?: DefaultOptionType) => void;
    onChangeWithObject?: (
        value: string | string[],
        option?: DefaultOptionType,
        selectedItems?: UserType | UserType[],
    ) => void;
    disabled?: boolean;
    filterList?: DynamicFilterListType[];
    filterOption?: (input: string, option: DefaultOptionType) => boolean;
    // localFilters?: RowsFilterType;
    excludeFilters?: RowsFilterType;
    mode?: 'multiple';
    selectedValue?: string | string[];
    onlyForProject?: string[];
}

const outUserSelect = React.forwardRef<any, IUserSelect>(function OutUserSelect(
    { onChange, onChangeWithObject, onlyForProject, filterOption: _, selectedValue, ...restProps },
    ref,
) {
    const valueProps = selectedValue
        ? {
              value: selectedValue,
          }
        : undefined;

    const filterFlexible = onlyForProject?.length
        ? `[{"or":[{"projects.project_id":"${onlyForProject.join('|')}"}]}]`
        : undefined;

    return (
        <DynamicList
            ref={ref}
            query={UsersShortQuery}
            fragmentList={UserShortListFragment}
            fragmentConnection={UserShortConnectionFragment}
            fragment={UserShortFragment}
            nameQuery={'users'}
            fields={['first_name', 'last_name'] as (keyof UserType)[]}
            template={'first_name last_name'}
            onChangeWithObject={(
                value: string | string[],
                option?: DefaultOptionType | DefaultOptionType[],
                selectedItems?: UserType | UserType[],
            ) => {
                onChangeWithObject?.(value, option, selectedItems);
            }}
            onChange={onChange}
            filterList={[]}
            countRecord={1000}
            filterFlexible={filterFlexible}
            {...restProps}
            {...valueProps}
        />
    );
});

export default outUserSelect;
